module.exports = __webpack_public_path__ + "img/user.6eff922c.png";